import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-6xl" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center md:justify-between mb-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading text-primary-800 mb-2" }, " Community Proposals "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500" }, " Shape our neighborhood together. Support proposals you believe in. ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" New Proposal ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "bg-gradient-to-r from-accent-50 to-blue-50 border border-accent-200 rounded-xl p-6 mb-8"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-1\"><h2 class=\"text-lg font-heading font-semibold text-primary-800 mb-3 flex items-center gap-2\"><svg class=\"w-5 h-5 text-accent-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg> How Community Proposals Work </h2><div class=\"grid md:grid-cols-3 gap-4 text-sm\"><div class=\"flex gap-3\"><div class=\"w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0\"><span class=\"text-accent-700 font-bold\">1</span></div><div><p class=\"font-medium text-primary-800\">Submit an Idea</p><p class=\"text-primary-500\"> Any neighbor can propose improvements, events, or initiatives for our community. </p></div></div><div class=\"flex gap-3\"><div class=\"w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0\"><span class=\"text-accent-700 font-bold\">2</span></div><div><p class=\"font-medium text-primary-800\">Gather Support</p><p class=\"text-primary-500\"> Proposals need support from 10 households to move forward to a formal vote. </p></div></div><div class=\"flex gap-3\"><div class=\"w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0\"><span class=\"text-accent-700 font-bold\">3</span></div><div><p class=\"font-medium text-primary-800\">Community Vote</p><p class=\"text-primary-500\"> Once threshold is met, it goes to a formal vote where every household has a say. </p></div></div></div><p class=\"mt-4 text-sm text-primary-600 bg-white/60 rounded-lg p-3\"><strong>Your voice matters!</strong> This is how we make decisions together as a community - from neighborhood events to how we use our shared resources. </p></div>", 1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "w-full max-w-2xl max-h-[90vh] overflow-y-auto" }
const _hoisted_13 = { class: "flex flex-wrap gap-2 mb-6" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 2,
  class: "grid gap-6 md:grid-cols-2 lg:grid-cols-3"
}
const _hoisted_16 = {
  key: 3,
  class: "text-center py-16 bg-white rounded-xl border border-primary-200 shadow-soft"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-16 h-16 mx-auto text-primary-300 mb-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-700 mb-2" }, " No proposals yet ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500 mb-6" }, " Be the first to suggest an improvement for our community! ", -1)
const _hoisted_20 = {
  key: 4,
  class: "grid gap-6 md:grid-cols-2 lg:grid-cols-3"
}

import { ref, computed, onMounted } from "vue";
import { useProposalStore } from "@/stores/proposals";
import ProposalCard from "@/components/proposals/ProposalCard.vue";
import CreateProposalForm from "@/components/proposals/CreateProposalForm.vue";
import SkeletonLoader from "@/components/ui/SkeletonLoader.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const proposalStore = useProposalStore();

const showCreateForm = ref(false);
const activeFilter = ref("all");

// Explainer dismissal
const EXPLAINER_STORAGE_KEY = "foxwood_proposals_explainer_dismissed";
const hideExplainer = ref(
  localStorage.getItem(EXPLAINER_STORAGE_KEY) === "true"
);

const dismissExplainer = () => {
  hideExplainer.value = true;
  localStorage.setItem(EXPLAINER_STORAGE_KEY, "true");
};

const filters = [
  { label: "All Active", value: "all" },
  { label: "Gathering Support", value: "gathering_support" },
  { label: "Ready for Vote", value: "ready_for_vote" },
  { label: "Voting", value: "voting" },
];

const loading = computed(() => proposalStore.loading);

const filteredProposals = computed(() => {
  if (activeFilter.value === "all") {
    return proposalStore.activeProposals;
  }
  return proposalStore.proposals.filter((p) => p.status === activeFilter.value);
});

const handleProposalCreated = (proposal: Proposal) => {
  showCreateForm.value = false;
  router.push(`/proposals/${proposal.id}`);
};

onMounted(async () => {
  try {
    await proposalStore.fetchProposals();
  } catch (err) {
    console.error("Failed to fetch proposals", err);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateForm.value = true)),
          class: "mt-4 md:mt-0 inline-flex items-center gap-2 px-6 py-3 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors shadow-soft"
        }, _hoisted_7)
      ]),
      (!hideExplainer.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", { class: "flex items-start justify-between gap-4" }, [
              _hoisted_9,
              _createElementVNode("button", {
                onClick: dismissExplainer,
                class: "text-primary-400 hover:text-primary-600 transition-colors p-1",
                title: "Dismiss"
              }, _hoisted_11)
            ])
          ]))
        : _createCommentVNode("", true),
      (showCreateForm.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showCreateForm.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(CreateProposalForm, {
                onCreated: handleProposalCreated,
                onCancel: _cache[1] || (_cache[1] = ($event: any) => (showCreateForm.value = false))
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filters, (filter) => {
          return _createElementVNode("button", {
            key: filter.value,
            onClick: ($event: any) => (activeFilter.value = filter.value),
            class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-full transition-colors", 
            activeFilter.value === filter.value
              ? 'bg-primary-800 text-white'
              : 'bg-white text-primary-600 hover:bg-primary-100 border border-primary-200'
          ])
          }, _toDisplayString(filter.label), 11, _hoisted_14)
        }), 64))
      ]),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(SkeletonLoader, { type: "card" }),
            _createVNode(SkeletonLoader, { type: "card" }),
            _createVNode(SkeletonLoader, { type: "card" }),
            _createVNode(SkeletonLoader, { type: "card" }),
            _createVNode(SkeletonLoader, { type: "card" }),
            _createVNode(SkeletonLoader, { type: "card" })
          ]))
        : (_unref(filteredProposals).length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showCreateForm.value = true)),
                class: "inline-flex items-center gap-2 px-6 py-3 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors"
              }, " Create the First Proposal ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredProposals), (proposal) => {
                return (_openBlock(), _createBlock(ProposalCard, {
                  key: proposal.id,
                  proposal: proposal
                }, null, 8, ["proposal"]))
              }), 128))
            ]))
    ])
  ]))
}
}

})